export default {
  BASE_URL: '/admin/cbm/requirement',
  api: [
    {
      name: 'tabList',
      desc: '管理后台页签列表',
      method: 'GET',
      path: '/tab/list'
    },
    {
      name: 'auditResult',
      desc: '申报结果数据字典',
      method: 'GET',
      path: '/dict/auditResult'
    },
    {
      name: 'list',
      desc: '管理后台页签列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'audit',
      desc: '审核操作',
      method: 'PUT',
      path: '/audit'
    },
    {
      name: 'auditResult',
      desc: '审核结果数据字典',
      method: 'GET',
      path: '/dict/auditResult'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/business/supply-demand.js